import { Instance, types } from 'mobx-state-tree'

import type { SelectOptions } from 'components/Select/Select'
import { MeasurementUnits, MeasurementUnitInstances, MeasurementUnitsEnum, measurementUnitsValues } from './MeasurementUnitModel'

function isMeasurementUnit(input: string): input is MeasurementUnitsEnum {
  return measurementUnitsValues.includes(input as MeasurementUnitsEnum)
}
const measurementUnitDisplayText = {
  [MeasurementUnitsEnum.Metric]: 'Metric (m, km, kg)',
  [MeasurementUnitsEnum.Imperial]: 'Imperial (in, mi, lb)',
} as const

const measurementUnitsOptions = Object.entries(measurementUnitDisplayText).map(([value, text]) => ({ value, text }))


export const DeploymentSettingsModel = types
  .model('DeploymentSettingsModel', {
    max_distance_to_landing_m: types.number,
    measurement_units: types.enumeration('MeasurementUnits', measurementUnitsValues),
  })
  .views((self) => ({
    get maxDistanceToLandingM() {
      return self.max_distance_to_landing_m
    },
    get measurementUnits(): MeasurementUnits {
      return MeasurementUnitInstances[self.measurement_units]
    }
  }))
  .actions((self) => ({
    setMeasurementUnits(maybeMeasurementUnits: string): void {
      if (!isMeasurementUnit(maybeMeasurementUnits)) {
        console.warn(`Tried to set '${maybeMeasurementUnits}' as a measurementUnits, which it isn't. Ignored.`)
        return
      }
      self.measurement_units = maybeMeasurementUnits
    },
  }))
  .views((self) => ({
    get availableMeasurementUnitsOptions(): SelectOptions {
      return measurementUnitsOptions
    },
    get selectedMeasurementUnitsOptions(): SelectOptions {
      const { measurement_units } = self
      return [{ value: measurement_units, text: measurementUnitDisplayText[measurement_units] }] as const
    },
  }))

export type DeploymentSettings = Instance<typeof DeploymentSettingsModel>